import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';

interface IVital {
  fieldName: string;
  friendlyName: string;
  fieldType: string;
  value?: string;
  position: number;
}

/**
 * TanStack Query version of useQueryProjectVitals
 * Fetches project vitals using HTTP client with parameter-based reactivity
 */
const useQueryProjectVitalsTanstack = (projectId: number | null) => {
  const httpClient = useHttpClient();

  return useQuery<IVital[]>({
    queryKey: ['projectVitals', projectId],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID not set');
      }
      const response = await httpClient.get(`/projects/${projectId}/vitals`);
      return response.data;
    },
    enabled: projectId !== null, // Only fetch when project ID is provided
  });
};

export default useQueryProjectVitalsTanstack;